import { render, staticRenderFns } from "./NotificationFollowings.vue?vue&type=template&id=5f372981&scoped=true&"
import script from "./NotificationFollowings.vue?vue&type=script&lang=ts&"
export * from "./NotificationFollowings.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationFollowings.vue?vue&type=style&index=0&id=5f372981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f372981",
  null
  
)

export default component.exports